import React from 'react';

export function IconLogo({ width = 204, height = 32 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      focusable="false"
      role="img"
      viewBox={`0 0 ${width} ${height}`}
      aria-label="AU Latitude Icon"
    >
      <path
        d="M4.9962 19.0015H23.6933V23.9977H2.59409C1.16125 23.9977 0 22.8364 0 21.4036V0.306702H4.9962V19.0015ZM11.6523 5.99122C13.3076 5.99122 14.6468 4.64969 14.6468 2.99678C14.6468 1.34387 13.3052 0.00234124 11.6523 0.00234124C9.99941 0.00234124 8.65789 1.34387 8.65789 2.99678C8.65789 4.64969 9.99941 5.99122 11.6523 5.99122ZM18.0088 2.99444C18.0088 1.34153 19.3503 0 21.0032 0C22.6561 0 23.9977 1.34153 23.9977 2.99444C23.9977 4.64735 22.6561 5.98888 21.0032 5.98888C19.3503 5.98888 18.0088 4.64735 18.0088 2.99444ZM24 12.3477C24 14.0029 22.6585 15.3421 21.0056 15.3421C19.3526 15.3421 18.0111 14.0006 18.0111 12.3477C18.0111 10.6948 19.3526 9.35323 21.0056 9.35323C22.6585 9.35323 24 10.6948 24 12.3477Z"
        fill="#0B2374"
      />
    </svg>
  );
}

export function FooterIcon({ width = 204, height = 32 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      focusable="false"
      role="img"
      viewBox={`0 0 ${width} ${height}`}
      aria-label="AU Latitude Icon"
    >
      <path
        d="M4.9962 19.0015H23.6933V23.9977H2.59409C1.16125 23.9977 0 22.8364 0 21.4036V0.306702H4.9962V19.0015ZM11.6523 5.99122C13.3076 5.99122 14.6468 4.64969 14.6468 2.99678C14.6468 1.34387 13.3052 0.00234124 11.6523 0.00234124C9.99941 0.00234124 8.65789 1.34387 8.65789 2.99678C8.65789 4.64969 9.99941 5.99122 11.6523 5.99122ZM18.0088 2.99444C18.0088 1.34153 19.3503 0 21.0032 0C22.6561 0 23.9977 1.34153 23.9977 2.99444C23.9977 4.64735 22.6561 5.98888 21.0032 5.98888C19.3503 5.98888 18.0088 4.64735 18.0088 2.99444ZM24 12.3477C24 14.0029 22.6585 15.3421 21.0056 15.3421C19.3526 15.3421 18.0111 14.0006 18.0111 12.3477C18.0111 10.6948 19.3526 9.35323 21.0056 9.35323C22.6585 9.35323 24 10.6948 24 12.3477Z"
        fill="white"
      />
    </svg>
  );
}
